import { all, takeEvery, put, call } from "redux-saga/effects";
import actions from "./actions";
import {
  getTablesRequest,
  getBillDetailsRequest,
} from "../../services/tablesInfoService";
import { getToken } from "../../utils/utility";
import { notification } from "antd";

export function* getTables({ startDate, endDate, restaurant }) {
  try {
    const token = getToken().get("idToken");
    const response = yield call(
      getTablesRequest,
      token,
      startDate,
      endDate,
      restaurant
    );
    if (response[0] === 200) {
      let key = 1;
      yield put({
        type: actions.GET_TABLES_SUCCESS,
        tables: response[1].map((x) => ({ ...x, key: key++ })),
      });
    } else if (response[0] === 500) {
      notification["error"]({
        message: "Няма връзка с базата",
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка",
    });
  }
}

export function* getBillDetails(parms) {
  try {
    const token = getToken().get("idToken");
    const response = yield call(getBillDetailsRequest, token, parms.billId);
    if (response[0] === 200) {
      let group_to_values = response[1].reduce(function (obj, item) {
        obj[item.Time] = obj[item.Time] || [];
        obj[item.Time].push(item);
        return obj;
      }, {});

      let groups = Object.keys(group_to_values).map(function (key) {
        return { time: key, orders: group_to_values[key] };
      });
      yield put({
        type: actions.TOGGAL_BILL_DETAILS_SUCCESS,
        bill: groups,
      });
    } else if (response[0] === 500) {
      notification["error"]({
        message: "Няма връзка с базата",
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка",
    });
  }
}

export default function* rootSaga() {
  yield all([
    yield takeEvery(actions.GET_TABLES_REQUEST, getTables),
    yield takeEvery(actions.TOGGAL_BILL_DETAILS_REQUEST, getBillDetails),
  ]);
}
